import type { Classification } from '@yes.technology/react-toolkit'
import { Button } from '@yes.technology/react-toolkit'
import useTaskStatusActions from 'component/TaskObjectCard/hooks/useTaskStatusActions/useTaskStatusActions'
import { TransportOrder } from 'component/TransportOrderCard/types'
import useKanbanContext from 'site/Renderer/components/Kanban/components/KanbanAutoColumns/useKanbanContext'
import { updateStatus } from 'status/shared'
import { StatusAction } from 'status/shared/situation.type'

type StatusActionsProps = {
  transportOrder: TransportOrder
  statusActions: StatusAction[]
  classification?: Classification
}

export default function StatusActions({
  transportOrder,
  statusActions,
  classification
}: StatusActionsProps) {
  const { onStatusChange } = useKanbanContext()

  const { displayedStatusActions } = useTaskStatusActions(
    statusActions,
    classification
  )

  const changeStatus = (destinationStatusCode: string) => {
    updateStatus({
      objectVersion: transportOrder.version,
      objectUuid: transportOrder.uuid,
      objectclassUuid: window.uuidObjectclassTransportorder,
      destinationStatusCode,
      showLoading: false
    })

    onStatusChange?.(transportOrder.uuid, destinationStatusCode)
  }

  return (
    <>
      {displayedStatusActions.map((statusAction) => (
        <Button
          key={statusAction.uuid}
          variant='primary'
          heightClass='semiSmall'
          onClick={() =>
            changeStatus(statusAction.destination_status?.[0]?.code)
          }
          style={{ marginBottom: 8 }}
        >
          {statusAction.des}
        </Button>
      ))}
    </>
  )
}
